'use client';

import { c as _c } from "react/compiler-runtime";
import { SearchInput } from '../../components';
import { FieldShell } from './FieldShell';
import { getFieldIds } from './utils';
import type { FieldValues } from 'react-hook-form';
import type { BaseComponentProps, BaseFieldProps } from './types';

/**
 * DeclarativeForm field config for the `searchInput` component variant.
 * Renders a `<SearchInput>` wired to react-hook-form + the standard form
 * label / description / error slots.
 */
export type SearchInputComponentProps = BaseComponentProps<typeof SearchInput>;
interface SearchInputFieldProps<TFieldValues extends FieldValues> extends BaseFieldProps<TFieldValues> {
  componentProps: SearchInputComponentProps;
}
export function SearchInputField(t0) {
  const $ = _c(24);
  const {
    field,
    fieldConfig,
    fieldState,
    componentProps,
    labelSize
  } = t0;
  let className;
  let componentDisabled;
  let id;
  let searchProps;
  if ($[0] !== componentProps) {
    ({
      id,
      disabled: componentDisabled,
      className,
      ...searchProps
    } = componentProps);
    $[0] = componentProps;
    $[1] = className;
    $[2] = componentDisabled;
    $[3] = id;
    $[4] = searchProps;
  } else {
    className = $[1];
    componentDisabled = $[2];
    id = $[3];
    searchProps = $[4];
  }
  const isDisabled = field.disabled || componentDisabled;
  let t1;
  if ($[5] !== fieldConfig || $[6] !== fieldState || $[7] !== id) {
    t1 = getFieldIds(fieldConfig, fieldState, id);
    $[5] = fieldConfig;
    $[6] = fieldState;
    $[7] = id;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const ids = t1;
  let t2;
  if ($[9] !== className || $[10] !== field.onChange || $[11] !== field.value || $[12] !== ids.describedBy || $[13] !== ids.fieldId || $[14] !== ids.isInvalid || $[15] !== isDisabled || $[16] !== searchProps) {
    t2 = <SearchInput {...searchProps} className={className} aria-describedby={ids.describedBy} aria-invalid={ids.isInvalid} clearValueOnType={true} disabled={isDisabled} id={ids.fieldId} onChange={field.onChange} value={field.value} />;
    $[9] = className;
    $[10] = field.onChange;
    $[11] = field.value;
    $[12] = ids.describedBy;
    $[13] = ids.fieldId;
    $[14] = ids.isInvalid;
    $[15] = isDisabled;
    $[16] = searchProps;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  let t3;
  if ($[18] !== fieldConfig || $[19] !== fieldState || $[20] !== ids || $[21] !== labelSize || $[22] !== t2) {
    t3 = <FieldShell fieldConfig={fieldConfig} fieldState={fieldState} ids={ids} labelSize={labelSize}>{t2}</FieldShell>;
    $[18] = fieldConfig;
    $[19] = fieldState;
    $[20] = ids;
    $[21] = labelSize;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  return t3;
}